import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
export default class GorbeaUserDetailsModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "entry", null);
    _defineProperty(this, "seasonParam", '');
    _defineProperty(this, "loading", true);
    _defineProperty(this, "vote", null);
    _defineProperty(this, "result", null);
    _defineProperty(this, "players", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.entry = this.attrs.entry;
    this.seasonParam = this.attrs.season;
    this.loadDetails();
  }
  className() {
    return 'GorbeaUserDetailsModal Modal--large';
  }
  title() {
    return "Pron\xF3stico de ".concat(this.entry.user() ? this.entry.user().displayName() : 'Usuario');
  }
  loadDetails() {
    this.loading = true;
    const p1 = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-vote',
      params: {
        season_id: this.entry.seasonId(),
        user_id: this.entry.userId()
      }
    });
    const p2 = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-result',
      params: {
        season_id: this.entry.seasonId()
      }
    });
    const p3 = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/players'
    }).catch(() => null);
    Promise.all([p1, p2, p3]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 3),
        voteResp = _ref2[0],
        resultResp = _ref2[1],
        playersResp = _ref2[2];
      if (voteResp && voteResp.data) {
        this.vote = voteResp.data.attributes;
      }
      if (resultResp && resultResp.data) {
        this.result = resultResp.data.attributes;
      }
      if (playersResp) {
        this.players = app.store.pushPayload(playersResp) || [];
      }
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  formatPlayer(value) {
    if (!value && value !== 0) return '-';
    const getName = val => {
      const num = parseInt(val, 10);
      if (!isNaN(num) && num > 0) {
        const found = this.players.find(p => parseInt(p.id(), 10) === num);
        if (found) return found.name();
        const fromStore = app.store.getById('nagusi_players', String(num));
        if (fromStore) return fromStore.name();
      }
      return String(val);
    };
    if (Array.isArray(value)) {
      if (value.length === 0) return '-';
      return value.map(getName).join(', ');
    }
    return getName(value);
  }
  content() {
    if (this.loading) {
      return m("div", {
        style: "text-align: center; padding: 40px;"
      }, m(LoadingIndicator, null));
    }
    const user = this.entry.user();
    const breakdown = this.entry.breakdown() || {};
    const classificationDetails = breakdown.classification_details || [];
    return m("div", {
      className: "GorbeaUserDetails"
    }, m("div", {
      className: "GorbeaUserDetails-profile"
    }, user && avatar(user, {
      className: 'Player-Avatar-Medium'
    }), m("div", {
      className: "GorbeaUserDetails-profileInfo"
    }, m("h4", {
      className: "GorbeaUserDetails-username"
    }, user ? username(user) : 'Usuario'), m("span", {
      className: "GorbeaUserDetails-totalScore"
    }, "Puntuaci\xF3n Total: ", this.entry.totalScore(), " puntos"))), m("div", {
      className: "Gorbea-Breakdown-Grid"
    }, m("div", {
      className: "GorbeaUserDetails-card GorbeaUserDetails-classification"
    }, m("h5", {
      className: "GorbeaUserDetails-cardTitle"
    }, "\uD83D\uDEE1\uFE0F Pron\xF3stico de Clasificaci\xF3n (", this.entry.scoreClassification(), " pts)"), m("div", {
      className: "GorbeaUserDetails-predictList"
    }, classificationDetails.map(item => {
      const isExact = item.user_pos === item.real_pos;
      const isNear = Math.abs(item.user_pos - item.real_pos) <= 2;
      const isMid = Math.abs(item.user_pos - item.real_pos) <= 4;
      let statusClass = 'is-far';
      if (isExact) {
        statusClass = 'is-exact';
      } else if (isNear) {
        statusClass = 'is-near';
      } else if (isMid) {
        statusClass = 'is-mid';
      }
      return m("div", {
        className: "GorbeaUserDetails-predictRow ".concat(statusClass)
      }, m("div", {
        className: "GorbeaUserDetails-teamNameInfo"
      }, m("span", {
        className: "GorbeaUserDetails-posNum"
      }, item.user_pos, "\xBA"), m("span", {
        className: "GorbeaUserDetails-teamName"
      }, item.name), item.is_athletic && m("span", {
        className: "badge badge-athletic"
      }, "Athletic")), m("div", {
        className: "GorbeaUserDetails-realPosInfo"
      }, m("span", null, "Real: ", item.real_pos, "\xBA"), m("span", {
        className: "GorbeaUserDetails-rowPoints"
      }, "+", item.total_points, " pts")));
    }))), m("div", {
      className: "GorbeaUserDetails-sideCols"
    }, m("div", {
      className: "GorbeaUserDetails-card"
    }, m("h5", {
      className: "GorbeaUserDetails-cardTitle"
    }, "\uD83C\uDFC3\u200D\u2642\uFE0F Goleadores y Asistentes"), m("table", {
      className: "Table GorbeaUserDetails-table"
    }, m("thead", null, m("tr", null, m("th", null, "Categor\xEDa"), m("th", null, "Pron\xF3stico"), m("th", {
      className: "center"
    }, "Real"), m("th", {
      className: "center"
    }, "Puntos"))), m("tbody", null, m("tr", null, m("td", null, m("strong", null, "Goleador Liga")), m("td", null, this.formatPlayer(this.vote ? this.vote.maxGoleadorLiga : null)), m("td", {
      className: "center"
    }, this.formatPlayer(this.result ? this.result.maxGoleadorLiga : null)), m("td", {
      className: "center bold ".concat(breakdown.max_goleador_liga_ok ? 'text-success' : 'text-danger')
    }, breakdown.max_goleador_liga_ok ? '+10' : '0')), m("tr", null, m("td", null, m("strong", null, "Goleador Total")), m("td", null, this.formatPlayer(this.vote ? this.vote.maxGoleadorTotal : null)), m("td", {
      className: "center"
    }, this.formatPlayer(this.result ? this.result.maxGoleadorTotal : null)), m("td", {
      className: "center bold ".concat(breakdown.max_goleador_total_ok ? 'text-success' : 'text-danger')
    }, breakdown.max_goleador_total_ok ? '+10' : '0')), m("tr", null, m("td", null, m("strong", null, "Asistente Liga")), m("td", null, this.formatPlayer(this.vote ? this.vote.maxAsistenteLiga : null)), m("td", {
      className: "center"
    }, this.formatPlayer(this.result ? this.result.maxAsistenteLiga : null)), m("td", {
      className: "center bold ".concat(breakdown.max_asistente_liga_ok ? 'text-success' : 'text-danger')
    }, breakdown.max_asistente_liga_ok ? '+10' : '0')), m("tr", null, m("td", null, m("strong", null, "Asistente Total")), m("td", null, this.formatPlayer(this.vote ? this.vote.maxAsistenteTotal : null)), m("td", {
      className: "center"
    }, this.formatPlayer(this.result ? this.result.maxAsistenteTotal : null)), m("td", {
      className: "center bold ".concat(breakdown.max_asistente_total_ok ? 'text-success' : 'text-danger')
    }, breakdown.max_asistente_total_ok ? '+10' : '0'))))), m("div", {
      className: "GorbeaUserDetails-card"
    }, m("h5", {
      className: "GorbeaUserDetails-cardTitle"
    }, "\uD83C\uDFC6 Copa del Rey"), m("div", {
      className: "GorbeaUserDetails-copaRow"
    }, m("div", {
      className: "GorbeaUserDetails-copaPicks"
    }, m("div", null, m("strong", null, "Pron\xF3stico:"), " ", m("span", {
      className: "GorbeaUserDetails-copaValue"
    }, this.vote ? this.vote.resultadoCopa : '-')), m("div", null, m("strong", null, "Real:"), " ", m("span", {
      className: "GorbeaUserDetails-copaValue"
    }, this.result ? this.result.resultadoCopa : '-'))), m("span", {
      className: "bold ".concat(breakdown.resultado_copa_ok ? 'text-success' : 'text-danger')
    }, breakdown.resultado_copa_ok ? '+15 pts' : '0 pts'))), m("div", {
      className: "GorbeaUserDetails-card"
    }, m("h5", {
      className: "GorbeaUserDetails-cardTitle"
    }, "\uD83D\uDCCA Estad\xEDsticas Especiales de Liga"), m("table", {
      className: "Table GorbeaUserDetails-table"
    }, m("thead", null, m("tr", null, m("th", null, "Estad\xEDstica"), m("th", {
      className: "center"
    }, "Pron\xF3stico"), m("th", {
      className: "center"
    }, "Real"), m("th", {
      className: "center"
    }, "Puntos"))), m("tbody", null, m("tr", null, m("td", null, m("strong", null, "Porter\xEDas a 0")), m("td", {
      className: "center"
    }, this.vote ? this.vote.porteriasCero : '-'), m("td", {
      className: "center"
    }, this.result ? this.result.porteriasCero : '-'), m("td", {
      className: "center bold ".concat(breakdown.porterias_cero_ok ? 'text-success' : 'text-danger')
    }, breakdown.porterias_cero_ok ? '+10' : '0')), m("tr", null, m("td", null, m("strong", null, "Goleadas favor")), m("td", {
      className: "center"
    }, this.vote ? this.vote.goleadasFavor : '-'), m("td", {
      className: "center"
    }, this.result ? this.result.goleadasFavor : '-'), m("td", {
      className: "center bold ".concat(breakdown.goleadas_favor_ok ? 'text-success' : 'text-danger')
    }, breakdown.goleadas_favor_ok ? '+10' : '0')), m("tr", null, m("td", null, m("strong", null, "Goleadas contra")), m("td", {
      className: "center"
    }, this.vote ? this.vote.goleadasContra : '-'), m("td", {
      className: "center"
    }, this.result ? this.result.goleadasContra : '-'), m("td", {
      className: "center bold ".concat(breakdown.goleadas_contra_ok ? 'text-success' : 'text-danger')
    }, breakdown.goleadas_contra_ok ? '+10' : '0'))))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/gorbea/GorbeaUserDetailsModal', GorbeaUserDetailsModal);